import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styles from "./EditOrgModal.module.scss";
import Modal from "components/Modal/Modal";
import FormElement from "components/FormElement/FormElement";
import Button from "components/Button/Button";
import Checkbox from "components/Checkbox/Checkbox";

import {
    loadActsAction,
    loadActsAllAction,
    updateOrgActsAction,
} from "store/actions/Actions";

const EditOrgModal = (props) => {
    const { loadActsAction, loadActsAllAction, updateOrgActsAction, ActsReducer, setShowModal, UserOrgSiteReducer } = props;
    const [acts, setActs] = useState([]);

    useEffect(() => {
        if (!ActsReducer.acts) {
            loadActsAction();
        } else {
            const a = [];
            ActsReducer.acts.forEach((act) => {
                a.push(act.id);
            });
            setActs(a);
        }
    }, [ActsReducer.acts, loadActsAction]);

    useEffect(() => {
        if (!ActsReducer.all) {
            loadActsAllAction();
        }
    }, [ActsReducer.all, loadActsAllAction]);

    const handleCheckbox = (e) => {
        try {
            console.log('handleCheckbox');
            e.persist();
            if (e.target.checked === true) {
                setActs((s) => ([
                    ...s,
                    e.target.value
                ]));
            } else {
                setActs((s) => ([
                    ...s.filter(item => item !== e.target.value)
                ]));
            }
        } catch (error) {
            console.log('error updating checkbox');
        }
    }

    const updateActs = (e) => {
        console.log('updateActs');
        console.log(acts);
        updateOrgActsAction({
            acts,
        });
        setShowModal(false);
    }

    return (
        <Modal className={styles.modal} setShowModal={props.setShowModal}>
            <p className={styles["modal-heading"]}>Edit Acts</p>

            <div className={styles["modal-content"]}>

                <FormElement labelText={''} htmlFor="acts">
                    {ActsReducer.all && ActsReducer.all.map(act => {
                        return (
                            <Checkbox
                                onChange={handleCheckbox}
                                className={styles.checkbox}
                                key={`${act.id}-asdasd`}
                                labelText={act.name}
                                disabled={UserOrgSiteReducer.selected.is_officer ? true : false}
                                value={act.id}
                                checked={acts.includes(act.id) || false}
                            />
                        );
                    })}
                </FormElement>

            </div>

            <div className={styles["modal-footer"]}>
                <Button
                    text="CANCEL"
                    color="secondary"
                    onClick={() => props.setShowModal(false)}
                />
                {!UserOrgSiteReducer.selected.is_officer && <Button
                    text="UPDATE"
                    className={styles.create}
                    onClick={updateActs}
                />
                }
            </div>
        </Modal>
    );
};

const mapStateToProps = state => ({
    ActsReducer: state.ActsReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadActsAction,
    loadActsAllAction,
    updateOrgActsAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EditOrgModal);
